// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zP4U","clinicsSelect":"styles_clinicsSelect__1h268"};